<template lang="pug">
  .pdp-sub-banner
    .container.md-mt-150m.md-mb-150m.md-pr-100m.md-pl-100m
      .fixed-width-tweak-upper
        .inner-wrap
          .card-wrap
            .swatch
                ImgBox(:media-obj="subImage")
            .product-info
              .name.xs-f-xsmall.max-at-tweak.brand-color-1
                span.bold Upcoming Subscription
                span {{ subName }}
              .ctas.xs-f-xsmall.max-at-tweak
                a.underline(:href="subUrl") Manage
                .separator.md-hide.lg-hide
                a.underline(v-if="moreColorsUrl" :href="moreColorsUrl") More colors
</template>

<script>
  import { mapState } from "vuex";
  import ImgBox from '@components/imgBox';

  export default {
    name: "PdpExistingSubBannerV2",

    components: {
      ImgBox
    },

    props: {
      quizCompleted: {
        type: Boolean,
        required: false
      },
      moreColorsUrl: {
        type: String,
        default: "",
        required: false
      }
    },

    computed: {
      ...mapState('pdp', ['subscription']),

      subName() {
        return this.subscription?.product?.name;
      },

      subImage() {
        return this.subscription?.product?.swatch;
      },

      subUrl() {
        let url;
        if (this.subscription.id) {
          url = `/dashboard/subscriptions/edit-subscription/${this.subscription.id}`;
        }

        return url;
      },
    }
  };
</script>

<style scoped lang="stylus">
  .pdp-sub-banner
    .inner-wrap
      display flex
      justify-content center
      align-items center
      width 100%
      max-width 600px
      margin 0 auto
      box-shadow 0 18px 46px 0 rgba(0, 0, 0, 0.06)
      padding 10px
      .card-wrap
        border 1px solid ui-color-4
        width 100%
        padding 15px
        background-color ui-color-1
        display flex
        justify-content flex-start
        align-items center
        gap 15px

        .swatch
          min-width 50px
          max-width 50px
          width 50px
          height 50px
          >>>.image-box
            img
              width 100%
              height 100% 
              object-fit cover
              border-radius 50%
              overflow hidden

        .product-info
          display flex
          align-items center
          gap 20px
          width 100%
          justify-content space-between
          letter-spacing -0.02em
          font-weight 600

          .name
            display flex
            flex-direction column
            align-items flex-start

          .ctas
            display flex
            align-items center
            gap 20px
    @media mq-tablet-less
      .inner-wrap
        padding 0
        .card-wrap
          border none
          align-items flex-start
          padding 10px
          .product-info
            flex-direction column
            align-items flex-start
            gap 10px

            .ctas
              gap 10px
              .separator
                height 10px
                width 2px
                background-color brand-color-1

</style>
